window.addEventListener("DOMContentLoaded", (event) => {
  // check if the browser actually supports the <video> element and to only setup the custom controls if it does.
  var supportsVideo = !!document.createElement("video").canPlayType;
  if (supportsVideo) {
    // set up custom controls
    // ...
    const isDesktopWidth = window.innerWidth >= 1024;
    var videoContainer = document.querySelector(".video-hero__content");
    if (isDesktopWidth) {
      var video = document.getElementById("video-desktop");
    } else {
      var video = document.getElementById("video-mobile");
    }
      
    // Hide the default controls
    if(video)video.controls = false;
    
    // var playpause = document.getElementById("playpause");

    // playpause.addEventListener("click", function (event) {
    //   event.stopPropagation();
    //   const videoTitle = document.querySelector(".video-hero__heading");
    //   const videoSubtitle = document.querySelector(".video-hero__subheading");

    //   playpause.classList.add("d-none");
    //   videoTitle.classList.add("d-none");
    //   videoSubtitle.classList.add("d-none");
    //   videoContainer.classList.add("video-hero__hide-cover");

    //   // initially muted video to prevent console error and unmute when video is playing
    //   video.muted = false;
    //   video.play();
    // });

    // Allow video to play/paused on click of video
    if(document.querySelector(".video-hero__video-wrapper"))document.querySelector(".video-hero__video-wrapper").addEventListener("click", function (event) {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });
  }
});
